import { createFileRoute } from '@tanstack/react-router';

import { CreateProductPage } from '@/features/products/CreateProductPage';
import { ScrapeCard } from '@/features/products/ScrapeCard';
import { useProductRegisters } from '@/features/products/useProductRegisters';

/*
  Its own route rather than a mode on the record, because the register's Add product opens it and
  a half-made product has no id to be at. The static path sits before $productId in the generated
  tree, so "new" is never read as an id.
*/
export const Route = createFileRoute('/_app/products/new')({
    component: NewProductRoute,
});

/** Create mode with the Create from URL card on top (ALS-45), which fills the form below it. */
function NewProductRoute() {
    const { registers } = useProductRegisters();
    return (
        <CreateProductPage
            renderScrape={({ onFill }) => <ScrapeCard registers={registers} onFill={onFill} />}
        />
    );
}
